<template>
  <component :is="challengeEndedComponent" />
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useChallengeStore } from '../../stores/challenge';
import { ChallengeTypeEnum } from '../../types/challenge';
import ContentBasedChallengeEnded from './ContentBasedChallengeEnded.vue';
import DefaultChallengeEnded from './DefaultChallengeEnded.vue';

const challengeStore = useChallengeStore();
const { challenge } = storeToRefs(challengeStore);

const challengeTypeToChallengeEnded = {
  [ChallengeTypeEnum.Values.contentBased]: ContentBasedChallengeEnded,
  valueBased: DefaultChallengeEnded,
  dailyTaskBased: DefaultChallengeEnded,
  percentBased: DefaultChallengeEnded,
  personalValueBased: DefaultChallengeEnded,
};
const challengeEndedComponent = challengeTypeToChallengeEnded[challenge.value.type];
</script>

<style lang="scss" scoped>
.header-section {
  display: grid;
  grid-template-columns: 2.5fr 0.5fr;
  height: 198px;
  gap: 16px;
}

</style>
